import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import img$1 from '../../../../assets/images/logo-footer.svg.js';
import img from '../../../../assets/images/amcare-logo.svg.js';
import css_248z from './footer.scss.js';
import img$2 from '../../../../assets/images/arrow-up-icon.svg.js';

class Footer extends s {
    constructor() {
        super();
        this.goUpText = 'Go up';
        this.goToHomePageText = 'Go to Homepage';
        this._query = '(max-width: 1365px)';
        this._isMobile = false;
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
    setAmcareMobileClasses() {
        if (this.isAmcare) {
            const sitemapMobileSlot = this.renderRoot.querySelector('slot[name="sitemap-mobile-item"]');
            if (!sitemapMobileSlot)
                return;
            const assignedElements = sitemapMobileSlot.assignedElements();
            const accordion = assignedElements.find(el => el.tagName.toLowerCase() === 'cvt-accordion');
            if (!accordion)
                return;
            const accordionItems = accordion.querySelectorAll('accordion-item');
            if (!accordionItems)
                return;
            accordionItems.forEach(item => {
                const itemsHeader = item.shadowRoot.querySelectorAll('.header');
                if (!itemsHeader)
                    return;
                itemsHeader.forEach(header => {
                    header.classList.add('amcare-footer__header');
                });
            });
        }
    }
    setAmcareDesktopClasses() {
        if (this.isAmcare) {
            const sitemapGroupSlot = this.renderRoot.querySelector(Footer.SITEMAP_GROUP_SELECTOR);
            if (!sitemapGroupSlot) {
                return;
            }
            const assignedElements = sitemapGroupSlot.assignedElements();
            const titleElements = assignedElements.flatMap(el => Array.from(el.querySelectorAll('.title')));
            titleElements.forEach(title => title.classList.add('amcare-footer__title'));
        }
    }
    firstUpdated() {
        requestAnimationFrame(() => {
            if (this.isAmcare) {
                this.setAmcareMobileClasses();
                this.setAmcareDesktopClasses();
            }
        });
        if (this.renderRoot
            .querySelector(Footer.SITEMAP_GROUP_SELECTOR)
            .assignedElements().length < 1)
            this.renderRoot.querySelector('.sitemap').style.display =
                'none';
        if (this.renderRoot
            .querySelector('slot[name="social-link"]')
            .assignedElements().length < 1) {
            this.renderRoot
                .querySelector('.row.social')
                .classList.add('empty');
        }
    }
    removeAmcareMobileClasses() {
        const sitemapMobileSlot = this.renderRoot.querySelector('slot[name="sitemap-mobile-item"]');
        if (!sitemapMobileSlot)
            return;
        const assignedElements = sitemapMobileSlot.assignedElements();
        const accordion = assignedElements.find(el => el.tagName.toLowerCase() === 'cvt-accordion');
        if (!accordion)
            return;
        const accordionItems = accordion.querySelectorAll('accordion-item');
        accordionItems.forEach(item => {
            var _a;
            const itemsHeader = (_a = item.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.header');
            if (!itemsHeader)
                return;
            itemsHeader.forEach(header => {
                header.classList.remove('amcare-footer__header');
            });
        });
    }
    removeAmcareDesktopClasses() {
        const sitemapGroupSlot = this.renderRoot.querySelector(Footer.SITEMAP_GROUP_SELECTOR);
        if (!sitemapGroupSlot)
            return;
        const assignedElements = sitemapGroupSlot.assignedElements();
        const titleElements = assignedElements.flatMap(el => Array.from(el.querySelectorAll('.title')));
        titleElements.forEach(title => title.classList.remove('amcare-footer__title'));
    }
    updated(changedProperties) {
        if (changedProperties.has('isAmcare')) {
            if (this.isAmcare) {
                this.setAmcareMobileClasses();
                this.setAmcareDesktopClasses();
            }
            else {
                this.removeAmcareMobileClasses();
                this.removeAmcareDesktopClasses();
            }
        }
    }
    render() {
        return $ `<lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query><div class="footer ${o({
            rtl: this.rtl || isRTL(),
        })}"><div class="top"><div class="row social"><slot name="social-link"></slot></div><div class="row logo"><a href="${this.homepageUrl}" aria-label="${this.goToHomePageText}"><img loading="lazy" src="${this.isAmcare ? img : img$1}" alt="${this.isAmcare ? 'Amcare Logo' : 'Convatec Logo'}" aria-hidden="true"></a></div><div class="row go-up"><a href="#top" class="icon-button style-dark" aria-label="Back to top" styleType="dark" ariaLabel="${this.goUpText}"><img slot="icon" .src="${img$2}" alt="Arrow pointing up" aria-hidden="true"></a></div></div><div class="sitemap"><slot name="sitemap-group"></slot></div><div class="sitemap-mobile"><slot name="sitemap-mobile-item"></slot></div><slot name="legal"></slot><slot name="bottom"></slot></div>`;
    }
}
Footer.styles = css_248z;
Footer.SITEMAP_GROUP_SELECTOR = 'slot[name="sitemap-group"]';
__decorate([
    e({ type: String })
], Footer.prototype, "homepageUrl", void 0);
__decorate([
    e()
], Footer.prototype, "goUpText", void 0);
__decorate([
    e()
], Footer.prototype, "goToHomePageText", void 0);
__decorate([
    e({ type: Boolean })
], Footer.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], Footer.prototype, "isAmcare", void 0);
customElements.define('cvt-footer', Footer);

export { Footer };
